// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"e9141724","220":"e0e3eef9","364":"97fa41fe","546":"1cd24590","856":"41cefac6"}[chunkId] + ".chunk.js";
};